import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { ContentDto } from '@app/modules/content-ai/content-ai.types';
import { ContentContainer } from '../../components';
import { ContentSocialVersion } from './ContentSocialVersion';
import { UserArticleViewer } from './UserArticleViewer';

export function ContentWizard_SocialVersionsStep({ content }: { content: ContentDto }) {
  return (
    <ContentContainer>
      <UserArticleViewer content={content} />
      {socialPlatforms.all().map((platform) => (
        <ContentSocialVersion key={platform.id} platform={platform} content={content} />
      ))}
    </ContentContainer>
  );
}
